var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.345,
    height: 36.671,
    viewBox: "0 0 38.345 36.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M21.024,2.2l4.325,8.763A2.064,2.064,0,0,0,26.9,12.091L36.575,13.5a2.065,2.065,0,0,1,1.145,3.522l-7,6.821a2.065,2.065,0,0,0-.593,1.828L31.78,35.3a2.065,2.065,0,0,1-3,2.177l-8.65-4.547a2.067,2.067,0,0,0-1.922,0l-8.65,4.547a2.065,2.065,0,0,1-3-2.177l1.652-9.632a2.065,2.065,0,0,0-.593-1.828l-7-6.821A2.065,2.065,0,0,1,1.771,13.5l9.671-1.405A2.064,2.064,0,0,0,13,10.961L17.322,2.2A2.064,2.064,0,0,1,21.024,2.2Z",
    transform: "translate(-0.001 -1.047)",
    fill: "#d4d4d4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyStar);
export default __webpack_public_path__ + "static/media/grey-star.42fc610089dd363722ca2633af94bb2a.svg";
export { ForwardRef as ReactComponent };